import Home from '../pages/Home'

import City from '../pages/City'
import AddCity from '../pages/City/actions/Add'
import EditCity from '../pages/City/actions/Edit'

import State from '../pages/State'
import AddState from '../pages/State/actions/Add'
import EditState from '../pages/State/actions/Edit'

import Roles from '../pages/Roles'
import AddRoles from '../pages/Roles/actions/Add'
import EditRoles from '../pages/Roles/actions/Edit'

// import Company Category files
import CompanyCategory from '../pages/CompanyCategory/index'
import AddCompanyCategory from '../pages/CompanyCategory/actions/Add'
import EditCompanyCategory from '../pages/CompanyCategory/actions/Edit'

// import Company Type files
import CompanyType from '../pages/CompanyType/index'
import AddCompanyType from '../pages/CompanyType/actions/Add'
import EditCompanyType from '../pages/CompanyType/actions/Edit'

// import Size Files
import Size from '../pages/Size/index'
import AddSize from '../pages/Size/actions/Add'
import EditSize from '../pages/Size/actions/Edit'

// import Material Files
import Material from '../pages/Material/index'
import AddMaterial from '../pages/Material/actions/Add'
import EditMaterial from '../pages/Material/actions/Edit'

import Color from '../pages/Colors/index'
import AddColor from '../pages/Colors/Actions/Add'
import EditColor from '../pages/Colors/Actions/Edit'

import Series from '../pages/Series/index'
import AddSeries from '../pages/Series/Actions/Add'
import EditSeries from '../pages/Series/Actions/Edit'

// import Country files
import Country from '../pages/Country/index'
import AddCountry from '../pages/Country/actions/Add'
import EditCountry from '../pages/Country/actions/Edit'

// import Team Files
import Team from '../pages/Team/index'
import AddTeam from '../pages/Team/actions/Add'
import EditTeam from '../pages/Team/actions/Edit'
import ViewTeam from '../pages/Team/actions/view'

// import User Profile Files
import UserProfile from '../pages/UserProfile/userProfile'

// import Marketing Files
import Marketing from '../pages/Marketing/index'

// import Task Files
import Task from '../pages/Task/index'
import AddTask from '../pages/Task/actions/Add'
import EditTask from '../pages/Task/actions/Edit'
import ViewTask from '../pages/Task/actions/View'
import TaskReopen from '../pages/Task/actions/TaskReopen'
//task  categories
import BigTaskList from '../pages/Task/task-categories/bigTask'
import PrintTaskList from '../pages/Task/task-categories/printTask'
import PaidTaskList from '../pages/Task/task-categories/paidTask'

// overduwe task
import OverdueTask from '../pages/OverdueTask/index'

// import Accounting Files
import Accounting from '../pages/Accounting/index'

// import Attendance files
import Attendance from '../pages/Attendance/index'

// import salary files
import Salary from '../pages/Salary/index'

// import leave files
import Leave from '../pages/Leave/index'

// import leads files
import Leads from '../pages/Leads/index'

// import company files
import Company from '../pages/Company/index'
import AddCompany from '../pages/Company/actions/Add'
import EditCompany from '../pages/Company/actions/Edit'
import ViewCompany from '../pages/Company/actions/View'

// import document files
import Document from '../pages/Document/index'

// import branding files
import CompanyBranding from '../pages/CompanyBranding/index'
import AddCompanyBranding from '../pages/CompanyBranding/actions/Add'
import EditCompanyBranding from '../pages/CompanyBranding/actions/Edit'
import ViewCompanyBranding from '../pages/CompanyBranding/actions/View'

import Products from '../pages/CompanyBranding/actions/Products'
import AddProduct from '../pages/CompanyBranding/actions/ProductAdd'
import EditProduct from '../pages/CompanyBranding/actions/ProductEdit'
import ViewProduct from '../pages/CompanyBranding/actions/ProductView'

//import big task type files
import BigTaskType from '../pages/BigTaskType/index'
import AddBigTaskType from '../pages/BigTaskType/actions/Add'
import EditBigTaskType from '../pages/BigTaskType/actions/Edit'

//import big task status files
import BigTaskStatus from '../pages/BigTaskStatus/index'
import AddBigTaskStatus from '../pages/BigTaskStatus/actions/Add'
import EditBigTaskStatus from '../pages/BigTaskStatus/actions/Edit'

// import task Details
import TaskDetail from '../pages/TaskDetails/TaskDetail'

import View360 from '../pages/360View/index'
import Add360View from '../pages/360View/actions/Add'
import Edit360View from '../pages/360View/actions/Edit'

import ArView from '../pages/ARView/index'
import AddArView from '../pages/ARView/actions/Add'
import EditArView from '../pages/ARView/actions/Edit'

import Metaverse from '../pages/Metaverse/index'
import AddMetaverse from '../pages/Metaverse/actions/Add'
import EditMetaverse from '../pages/Metaverse/actions/Edit'

import TaskStatus from '../pages/TaskStatus/index'
import AddTaskStatus from '../pages/TaskStatus/actions/Add'
import EditTaskStatus from '../pages/TaskStatus/actions/Edit'

import SocialMedia from '../pages/SocialMedia/TeamSocialMedia/index'
import ViewSocialMedia from '../pages/SocialMedia/TeamSocialMedia/View'
import Notification from '../pages/Notification'
import SocialList from '../pages/SocialList'

import Festival from '../pages/Events'
import AddFestival from '../pages/Events/actions/Add'
import ViewFestival from '../pages/Events/actions/View'
import EditFestival from '../pages/Events/actions/Edit'

import FestivalList from '../pages/FestivalList'

import Dynamic360 from '../pages/Dynamic360/index'
import AddDynamic360 from '../pages/Dynamic360/actions/Add'
import EditDynamic360 from '../pages/Dynamic360/actions/Edit'

import Library from '../pages/Library/index'
import AddLibrary from '../pages/Library/actions/Add'
import EditLibrary from '../pages/Library/actions/Edit'
import ViewLibrary from '../pages/Library/actions/View'

import LibraryCategory from '../pages/libraryCategory/index'
import AddLibraryCategory from '../pages/libraryCategory/actions/Add'
import EditLibraryCategory from '../pages/libraryCategory/actions/Edit'


const AllRoutes = [
  { path: '/', element: <Home />, permission: { read: true } },

  { path: '/city', element: <City />, permission: { read: true } },
  { path: '/city/add', element: <AddCity />, permission: { read: true } },
  { path: '/city/edit/:id', element: <EditCity />, permission: { read: true } },

  { path: '/state', element: <State />, permission: { read: true } },
  { path: '/state/add', element: <AddState />, permission: { read: true } },
  {
    path: '/state/edit/:id',
    element: <EditState />,
    permission: { read: true },
  },

  { path: '/roles', element: <Roles />, permission: { read: true } },
  { path: '/roles/add', element: <AddRoles />, permission: { read: true } },
  {
    path: '/roles/edit/:id',
    element: <EditRoles />,
    permission: { read: true },
  },

  {
    path: '/companycategory',
    element: <CompanyCategory />,
    permission: { read: true },
  },
  {
    path: '/companycategory/add',
    element: <AddCompanyCategory />,
    permission: { read: true },
  },
  {
    path: '/companycategory/edit/:id',
    element: <EditCompanyCategory />,
    permission: { read: true },
  },

  {
    path: '/companytype',
    element: <CompanyType />,
    permission: { read: true },
  },
  {
    path: '/companytype/add',
    element: <AddCompanyType />,
    permission: { read: true },
  },
  {
    path: '/companytype/edit/:id',
    element: <EditCompanyType />,
    permission: { read: true },
  },

  { path: '/size', element: <Size />, permission: { read: true } },
  { path: '/size/add', element: <AddSize />, permission: { read: true } },
  { path: '/size/edit/:id', element: <EditSize />, permission: { read: true } },

  { path: '/material', element: <Material />, permission: { read: true } },
  {
    path: '/material/add',
    element: <AddMaterial />,
    permission: { read: true },
  },
  {
    path: '/material/edit/:id',
    element: <EditMaterial />,
    permission: { read: true },
  },

  { path: '/color', element: <Color />, permission: { read: true } },
  { path: '/color/add', element: <AddColor />, permission: { read: true } },
  {
    path: '/color/edit/:id',
    element: <EditColor />,
    permission: { read: true },
  },

  { path: '/series', element: <Series />, permission: { read: true } },
  { path: '/series/add', element: <AddSeries />, permission: { read: true } },
  {
    path: '/series/edit/:id',
    element: <EditSeries />,
    permission: { read: true },
  },

  { path: '/country', element: <Country />, permission: { read: true } },
  { path: '/country/add', element: <AddCountry />, permission: { read: true } },
  {
    path: '/country/edit/:id',
    element: <EditCountry />,
    permission: { read: true },
  },

  { path: '/team', element: <Team />, permission: { read: true } },
  { path: '/team/add', element: <AddTeam />, permission: { read: true } },
  { path: '/team/edit/:id', element: <EditTeam />, permission: { read: true } },
  { path: '/team/view/:id', element: <ViewTeam />, permission: { read: true } },

  { path: '/profile', element: <UserProfile />, permission: { read: true } },
  {
    path: '/bigtasktype',
    element: <BigTaskType />,
    permission: { read: true },
  },
  {
    path: '/bigtasktype/add',
    element: <AddBigTaskType />,
    permission: { read: true },
  },
  {
    path: '/bigtasktype/edit/:id',
    element: <EditBigTaskType />,
    permission: { read: true },
  },

  {
    path: '/bigtaskstatus',
    element: <BigTaskStatus />,
    permission: { read: true },
  },
  {
    path: '/bigtaskstatus/add',
    element: <AddBigTaskStatus />,
    permission: { read: true },
  },
  {
    path: '/bigtaskstatus/edit/:id',
    element: <EditBigTaskStatus />,
    permission: { read: true },
  },
  { path: '/task', element: <Task />, permission: { read: true } },
  { path: '/task/add', element: <AddTask />, permission: { read: true } },
  { path: '/task/edit/:id', element: <EditTask />, permission: { read: true } },
  { path: '/task/view/:id', element: <ViewTask />, permission: { read: true } },

  {
    path: '/bigTask',
    element: <BigTaskList />,
    permission: { read: true },
  },
  {
    path: '/printTask',
    element: <PrintTaskList />,
    permission: { read: true },
  },
  {
    path: '/paidTask',
    element: <PaidTaskList />,
    permission: { read: true },
  },
  { path: '/bigTask/edit/:id', element: <EditTask />, permission: { read: true } },
  { path: '/bigTask/view/:id', element: <ViewTask />, permission: { read: true } },
  { path: '/printTask/edit/:id', element: <EditTask />, permission: { read: true } },
  { path: '/printTask/view/:id', element: <ViewTask />, permission: { read: true } },
  { path: '/paidTask/edit/:id', element: <EditTask />, permission: { read: true } },
  { path: '/paidTask/view/:id', element: <ViewTask />, permission: { read: true } },

   {
    path: '/overdue-task',
    element: <OverdueTask />,
    permission: { read: true },
  },
  
  { path: '/marketing', element: <Marketing />, permission: { read: true } },

  { path: '/accounting', element: <Accounting />, permission: { read: true } },

  { path: '/attendance', element: <Attendance />, permission: { read: true } },

  { path: '/leave', element: <Leave />, permission: { read: true } },

  { path: '/salary', element: <Salary />, permission: { read: true } },

  { path: '/leads', element: <Leads />, permission: { read: true } },

  { path: '/company', element: <Company />, permission: { read: true } },
  { path: '/company/add', element: <AddCompany />, permission: { read: true } },
  {
    path: '/company/edit/:id',
    element: <EditCompany />,
    permission: { read: true },
  },
  {
    path: '/company/view/:id',
    element: <ViewCompany />,
    permission: { read: true },
  },

  { path: '/document', element: <Document />, permission: { read: true } },

  {
    path: '/company-branding',
    element: <CompanyBranding />,
    permission: { read: true },
  },
  {
    path: '/company-branding/add/:id',
    element: <AddCompanyBranding />,
    permission: { read: true },
  },
  {
    path: '/company-branding/edit/:id',
    element: <EditCompanyBranding />,
    permission: { read: true },
  },
  {
    path: '/company-branding/view/:id',
    element: <ViewCompanyBranding />,
    permission: { read: true },
  },
  {
    path: '/company-branding/products/:id',
    element: <Products />,
    permission: { read: true },
  },
  {
    path: '/company-branding/products/:id/add-product',
    element: <AddProduct />,
    permission: { read: true },
  },
  {
    path: '/company-branding/products/:id/edit-product/:productId',
    element: <EditProduct />,
    permission: { read: true },
  },
  {
    path: '/company-branding/products/:id/view-product/:productId',
    element: <ViewProduct />,
    permission: { read: true },
  },

  {
    path: '/task-detail/:id',
    element: <TaskDetail />,
    permission: { read: true },
  },

  { path: '/360view', element: <View360 />, permission: { read: true } },
  { path: '/360view/add', element: <Add360View />, permission: { read: true } },
  {
    path: '/360view/edit/:id',
    element: <Edit360View />,
    permission: { read: true },
  },

  { path: '/arview', element: <ArView />, permission: { read: true } },
  { path: '/arview/add', element: <AddArView />, permission: { read: true } },
  {
    path: '/arview/edit/:id',
    element: <EditArView />,
    permission: { read: true },
  },

  { path: '/metaverse', element: <Metaverse />, permission: { read: true } },
  {
    path: '/metaverse/add',
    element: <AddMetaverse />,
    permission: { read: true },
  },
  {
    path: '/metaverse/edit/:id',
    element: <EditMetaverse />,
    permission: { read: true },
  },

  { path: '/dynamic-360', element: <Dynamic360 />, permission: { read: true } },
  {
    path: '/dynamic-360/add',
    element: <AddDynamic360 />,
    permission: { read: true },
  },
  {
    path: '/dynamic-360/edit/:id',
    element: <EditDynamic360 />,
    permission: { read: true },
  },

  { path: '/task-status', element: <TaskStatus />, permission: { read: true } },
  {
    path: '/task-status/add',
    element: <AddTaskStatus />,
    permission: { read: true },
  },
  {
    path: '/task-status/edit/:id',
    element: <EditTaskStatus />,
    permission: { read: true },
  },
    {
    path: '/task/reopen/:id',
    element: <TaskReopen />,
    permission: { read: true },
  },

  {
    path: '/notification',
    element: <Notification />,
    permission: { read: true },
  },
  { path: '/social-list', element: <SocialList />, permission: { read: true } },
  // { path: "/social-media", element: <SocialMedia />, permission: { read: true } },
  // { path: "/social-media/view/:id", element: <ViewSocialMedia />, permission: { read: true } },

  {
    path: '/festival-list',
    element: <FestivalList />,
    permission: { read: true },
  },

  { path: '/festival', element: <Festival />, permission: { read: true } },
  {
    path: '/festival/add',
    element: <AddFestival />,
    permission: { read: true },
  },
  {
    path: '/festival/view/:id',
    element: <ViewFestival />,
    permission: { read: true },
  },
  {
    path: '/festival/edit/:id',
    element: <EditFestival />,
    permission: { read: true },
  },

  { path: '/library', element: <Library />, permission: { read: true } },
  { path: '/library/add', element: <AddLibrary />, permission: { read: true } },
  {
    path: '/library/edit/:id',
    element: <EditLibrary />,
    permission: { read: true },
  },
  {
    path: '/library/view/:id',
    element: <ViewLibrary />,
    permission: { read: true },
  },

  {
    path: '/librarycategory',
    element: <LibraryCategory />,
    permission: { read: true },
  },
  {
    path: '/librarycategory/add',
    element: <AddLibraryCategory />,
    permission: { read: true },
  },
  {
    path: '/librarycategory/edit/:id',
    element: <EditLibraryCategory />,
    permission: { read: true },
  },
]

export default AllRoutes
